module.exports = __webpack_public_path__ + "img/2025-09-19a_1.db27dc50.jpg";